<template>
  <vuex-table
    :fields="fields"
    :auto_start="false"
    table_store="mailer/stats/detailed"
    @click_row="onClick"
  >
    <template slot="body" slot-scope="{ item }">
      <tooltip
        placement="top"
        theme="light"
        min-width="300"
        max-width="300"
        :transfer="true"
        :content="item.body"
      >
        <div class="d-inline-block text-truncate" style="max-width: 350px">
          {{ item.body }}
        </div>
      </tooltip>
    </template>

    <template slot="status" slot-scope="{ formatted: value }">
      <status-badge :value="value" />
    </template>
  </vuex-table>
</template>

<script>
  import StatusBadge from '@mailer/components/messages/messages-badge-state';
  import { StatsModalService } from '@mailer/modals/StatsModalService';
  import { toAccountTimezoneDateWithTime } from '@shared/helpers/date_format';

  export default {
    components: { StatusBadge },
    computed: {
      fields: function () {
        return [
          {
            key: 'name',
            label: this.$t('mailer.message.field.name')
          },
          {
            key: 'destination',
            label: this.$t('mailer.message.field.dst'),
            sortable: false,
            thStyle: {
              minWidth: '190px'
            }
          },

          {
            key: 'source',
            label: this.$t('mailer.message.field.sender_name'),
            thStyle: {
              maxWidth: '120px'
            }
          },

          {
            key: 'body',
            label: this.$t('mailer.message.field.body'),
            sortable: false
          },

          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            class: 'table-created_at',
            formatter: (value) => (value ? toAccountTimezoneDateWithTime(value) : ''),
          },

          {
            key: 'status',
            label: this.$t('shared.component.table.field.status'),
            sortable: true,
            thStyle: {
              minWidth: '120px'
            }
          },

          {
            key: 'total_parts',
            label: this.$t('mailer.message.field.total_parts'),
            sortable: false,
            thStyle: {
              minWidth: '130px'
            }
          },

          {
            key: 'client_cost',
            label: this.$t('mailer.stats.general.field.cost'),
            sortable: false,
            thStyle: {
              minWidth: '130px'
            },
            formatter: (val) => this.$numeral.currency(val)
          },
          {
            key: 'source_type',
            label: this.$t('mailer.message.field.source_type'),
            sortable: false,
            formatter: (type) => this.$t(`mailer.stats.general.filter.source.values.${type}`)
          }
        ];
      }
    },
    methods: {
      onClick(item) {
        if (item.total_parts > 1) {
          StatsModalService.view(item.part_group);
        }
      }
    }
  };
</script>
